import { render, staticRenderFns } from "./StripeCancellationFee.vue?vue&type=template&id=19b6cab4&"
import script from "./StripeCancellationFee.vue?vue&type=script&lang=js&"
export * from "./StripeCancellationFee.vue?vue&type=script&lang=js&"
import style0 from "./StripeCancellationFee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports